import React from 'react'
import {
  listTimelineRootAnalyses,
  type AnalysisTimelineRootCandidate,
} from '../services/analysisService'

type UseTimelineRootAnalysesForLinkResult = {
  items: AnalysisTimelineRootCandidate[]
  selected: AnalysisTimelineRootCandidate | null
  loading: boolean
  error: string | null
}

export function useTimelineRootAnalysesForLink(
  enabled: boolean,
  selectedRootId: number | null,
  excludeAnalysisId: number | null,
): UseTimelineRootAnalysesForLinkResult {
  const [items, setItems] = React.useState<AnalysisTimelineRootCandidate[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const selected = React.useMemo(() => {
    if (!enabled) return null
    if (selectedRootId == null) return null
    const targetId = Number(selectedRootId)
    if (!Number.isFinite(targetId)) return null
    return items.find((it) => Number(it.id) === targetId) ?? null
  }, [enabled, items, selectedRootId])

  React.useEffect(() => {
    if (!enabled) {
      setItems([])
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    listTimelineRootAnalyses()
      .then((rows) => {
        if (!active) return
        const excludeId =
          excludeAnalysisId != null && Number.isFinite(Number(excludeAnalysisId))
            ? Math.floor(Number(excludeAnalysisId))
            : null
        const filtered = excludeId
          ? (rows || []).filter((it) => Number(it.id) !== excludeId)
          : rows || []
        setItems(filtered)
      })
      .catch((e: any) => {
        if (!active) return
        setItems([])
        setError(e?.message || 'Falha ao carregar posts de timeline')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, excludeAnalysisId])

  return { items, selected, loading, error }
}
